import { Box, Paper, IconButton } from "@mui/material";
import { AddCommentOutlined } from "@mui/icons-material";
import makeStyles from '@mui/styles/makeStyles';
import { useState } from "react";
import { CommentType } from "./CommentContainer";
import AddCommentCard from "./AddCommentCard"

const useStyles = makeStyles(theme => ({
    buttonsPaper: {
        margin: theme.spacing(2),
        borderRadius: 32,
        zIndex: theme.zIndex.modal
    },
    buttons: {
        position: "absolute",
        right: `-${theme.spacing(2)}`,
        top: 0,
        display: "flex",
        justifyContent: "right",
        padding: theme.spacing(2),
        zIndex: 10
    }
}));

interface IProp
{
    getSelectionDetails: () => CommentType
}

export default function AddCommentButton({ getSelectionDetails }: IProp)
{
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) =>
    {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () =>
    {
        setAnchorEl(null);
    };

    return (
        <Box className={classes.buttons}>
            <Paper className={classes.buttonsPaper}>
                <IconButton style={{ color: "green" }} onClick={handleClick} size="large">
                    <AddCommentOutlined style={{ transform: "scaleX(-1)" }} />
                </IconButton>
            </Paper>
            <AddCommentCard target={anchorEl} getSelectionDetails={getSelectionDetails} onClose={handleClose} />
        </Box>
    );
}